import {
  buildImageKitUrl,
  type ImageKitPreset,
} from "./imageKit";

export const PLATFORM_SITE_NAME = "Tercer Espacio";

export const PLATFORM_LOGO_SRC = `${import.meta.env.BASE_URL}images/logo-magenta.png`;

export const PLATFORM_FAVICON_SRC = `${import.meta.env.BASE_URL}logo.svg`;

export type TenantLogoVariant = Extract<
  ImageKitPreset,
  "navbar" | "sidebar" | "login"
>;

/**
 * Builds alt text for a tenant or platform logo.
 */
export const buildLogoAlt = (siteName: string): string =>
  `Logo de ${siteName}`;

/**
 * ImageKit URL for a tenant logo by slug.
 */
export const getTenantLogoUrl = (
  slug: string,
  variant: TenantLogoVariant,
): string => buildImageKitUrl(`spaces/tenant-logos/${slug}.webp`, variant);

/**
 * ImageKit URL for a tenant favicon by slug.
 */
export const getTenantFaviconUrl = (slug: string): string =>
  buildImageKitUrl(`spaces/tenant-favicons/${slug}.webp`, "favicon");
